// Environment configuration for AgriFinOpsBordereauFrontEnd in DEV

export const environment = {
  production: false,
  environmentName: 'dev',
  apiBaseUrl: 'https://apiapp-crop-agrifinops-bdx-dev.azurewebsites.net/',
  logging: true,
  featureFlags: {
    enableNewDashboard: true,
    enableBetaFeatures: false
  },
  azureClientId: 'f5c5aec9-ce21-4bc1-8a8e-130a691ad7bc',
  azureTenantId: '885e124e-4dc7-41ed-a268-3e401a62cead',
  redirectUri: 'https://dev-agrifinops-bdx.hudsoncrop.com'
};
